
// exporting the component
import { computed, defineComponent } from 'vue';
import TimerComponent from './Timer.vue';
import { useStore } from '@/store';
// import { NOTIFY } from '@/store/mutation-types';
import { NotificationType } from '@/interfaces/INotifications';
// import { notificationMixin } from '@/mixins/notify';
import useNotificator from '@/hooks/notificator';
// import { useStore } from 'vuex';
// import { key } from '@/store';

export default defineComponent({
  name: 'FormComponent',
  emits: ['onSavingTask'],
  components: {
    TimerComponent
  },
  data() {
    return {
      description: '',
      projectId: ''
    };
  },
  // mixins --> replaced by custom hook
  // mixins: [notificationMixin],
  methods: {
    endTask(timeInSeconds: number): void {
      const project = this.projects.find(proj => proj.id === this.projectId);
      if (!project) {
        // this.store.commit(NOTIFY, {
        //   title: 'Ops!',
        //   text: 'Selecione um projeto antes de finalizar a tarefa!',
        //   type: NotificationType.FAILURE
        // });
        // Usando mixins
        this.notify(NotificationType.FAILURE, 'Ops!', 'Selecione um projeto antes de finalizar a tarefa!');
        return;
      }
      this.$emit('onSavingTask', {
        durationInSeconds: timeInSeconds,
        description: this.description,
        // finding the current project according to the selected one from the store (setup below)
        project: this.projects.find(proj => proj.id === this.projectId)
      });
      this.description = '';
    }
  },
  // using the global states configured in the Vuex Store the most modern way: with composition API setup() and `computed`
  setup() {
    // const store = useStore(key);
    // Replacing the useStore above for our custom useStore:
    const store = useStore();
    // using custom hook
    const { notify } = useNotificator();
    return {
      store,
      notify,
      projects: computed(() => store.state.projects)
    };
  }
});
